import React,{useEffect} from "react";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t, i18n } = useTranslation();
  
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      localStorage.setItem("lng", lng);
    };
  
    useEffect(() => {
      changeLanguage(localStorage.getItem("lng") || "en");
    }, []);;
  return (
    <>
      <section id="about" className="wrapper-intro px-4 py-10 sm:px-6 lg:px-8 bg-gradient-to-r from-primary/100 to-primaryDark/70 backdrop-blur-lg shadow-lg text-white">
        {/* Заголовок */}
       <div className="  rounded-xl  max-w-7xl mx-auto mt-10 p-6 bg-white/20 backdrop-blur-sm shadow-md ">
       <div className=" header justify-center flex my-14">
          <h1 className=" text-3xl sm:text-4xl lg:text-5xl font-semibold text-center ">
           
            {t("about_header")}
          </h1>
        </div>

        {/* Контент */}
        <div className=" max-w-7xl mx-auto mt-10 p-0 sm:p-6 text-start sm:text-justify content flex container m-auto flex-wrap justify-between items-start mb-9 space-y-8 lg:space-y-0">
          {/* Левый текстовый блок */}
          <div className="content_text  w-full  px-0 text-xl  sm:px-10">
            <p>
              {t("about_text1")}
            </p>
            <p className="mt-4">
              {t("about_text2")}
            </p>
            <p className="mt-4">
             { t("about_text3")}
            </p>
          </div>

        
        </div>
       </div>
      </section>
    </>
  );
};

export default AboutUs;
